"use client";

import type { CSSProperties, FC, Ref } from "react";
import { Placeholder, Stack, Message, Flex } from "@huub-web/ui";
import { rem } from "@huub-web/utils";

import { useAsyncTemplates } from "../../hooks/useAsyncTemplates";
import { TemplatesParser } from "../../components/TemplatesParser";

export interface AsyncTemplateProps {
  id: string;
  endpoint: string;
  level?: number;
  type?: "managed" | "default";
}

/**
 * AsyncTemplate component
 *
 * A template component for handling asynchronous operations
 */
export const AsyncTemplate: FC<
  AsyncTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ id, endpoint, level = 2, type = "managed", ref }) => {
  const { loading, hasLoadedOnce, error, templatesData } = useAsyncTemplates(
    endpoint,
    id,
  );

  return (
    <>
      {/* {loading ? "loading" : "not loading"} */}
      {type === "default" &&
        (!loading || hasLoadedOnce) &&
        templatesData &&
        !error && <TemplatesParser level={level} templates={templatesData} />}

      {type === "managed" && (
        <Stack
          ref={ref}
          id={id}
          reveal
          grow
          style={
            {
              width: "100%",
              transition: "opacity 0.3s ease-in-out",
              ...(loading && hasLoadedOnce
                ? { opacity: 0.5, pointerEvents: "none" }
                : {}),
            } as CSSProperties
          }
        >
          {loading && !hasLoadedOnce && (
            <Flex direction="column" gap="s">
              <Placeholder height={rem(80)} />
              <Placeholder height={rem(80)} />
              <Placeholder height={rem(80)} />
            </Flex>
          )}
          {(!loading || hasLoadedOnce) && templatesData && !error && (
            <TemplatesParser level={level} templates={templatesData} />
          )}
          {error && <Message variant="error">{error}</Message>}
        </Stack>
      )}
    </>
  );
};
